import { StreamingEvent } from '../../types/interface';

// Helper function to parse Server-Sent Events
export const parseStreamingEvent = (data: string): StreamingEvent | null => {
  if (!data.startsWith('data: ')) {
    return null;
  }

  try {
    const jsonData = data.substring(6); // Remove 'data: ' prefix
    const parsed = JSON.parse(jsonData) as StreamingEvent;

    // Validate required fields
    if (!parsed.type || !parsed.thread_id || !parsed.timestamp) {
      return null;
    }

    return parsed;
  } catch (error) {
    return null;
  }
};

// Helper function to format streaming content
export const formatStreamingContent = (content: string): string => {
  return content
    .replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>')
    .replace(/\*(.*?)\*/g, '<em>$1</em>')
    .replace(/\n/g, '<br/>')
    .replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener noreferrer">$1</a>');
};

// Helper function to map position to role
export const mapPositionToRole = (position: string | undefined): string => {
  if (!position) return 'Guest';

  const positionLower = position.toLowerCase();

  if (positionLower.includes('admin') || positionLower.includes('administrator')) {
    return 'Admin';
  }
  if (positionLower.includes('manager') || positionLower.includes('lead')) {
    return 'Manager';
  }
  if (positionLower.includes('intern') || positionLower.includes('trainee') || positionLower.includes('employee')) {
    return 'Employee';
  }
  if (positionLower.includes('guest') || positionLower.includes('visitor')) {
    return 'Guest';
  }

  return 'Guest';
};

// Helper function to check if value is numeric
export const isNumeric = (value: string): boolean => {
  return /^-?\d+$/.test(value);
};
